var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "AppDialog",
        {
          attrs: {
            title: "请选择机构",
            width: "434px",
            loading: _vm.loading,
            height: "auto",
            top: _vm.top,
          },
          on: { success: _vm.sure },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "switchOrg",
            },
            [
              _c(
                "div",
                { staticClass: "orgList" },
                _vm._l(_vm.orgList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "orgItem",
                      class: {
                        active:
                          _vm.organizationId === item.organizationId &&
                          item.status !== 1,
                        disabled: item.status === 1,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleChangeOrg(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "orgLogo" }, [
                        item.organizationUrl
                          ? _c("img", { attrs: { src: item.organizationUrl } })
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "orgName" }, [
                        _vm._v(_vm._s(item.name)),
                      ]),
                      _vm.organizationId === item.organizationId &&
                      item.status !== 1
                        ? _c("img", {
                            staticClass: "checkIcon",
                            attrs: {
                              src: require("@/assets/image/login/check.png"),
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                { staticClass: "m-t-20" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "logoBtn",
                      staticStyle: {
                        width: "380px",
                        height: "40px",
                        margin: "0 30px 0 24px",
                      },
                      attrs: {
                        type: "primary",
                        loading: _vm.loading,
                        disabled: !_vm.organizationId,
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleIntoSystem.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" 进入系统 ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showTips,
            width: "800px",
            title: "重要通知",
            height: "200px",
            "show-close": false,
            "close-on-click-modal": false,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showTips = $event
            },
          },
        },
        [
          _c("div", { staticClass: "delisting-tips" }, [
            _vm._v(" 为了更好的提供系统服务，系统地址已升级到 "),
            _c(
              "a",
              { attrs: { href: "https://lhhokcp.hokkj.cn", target: "_blank" } },
              [_vm._v(_vm._s(_vm.needJumpTo))]
            ),
            _c(
              "span",
              {
                staticClass: "delisting-tips-copy",
                on: { click: _vm.copyUrl },
              },
              [_vm._v("点击复制")]
            ),
            _vm._v(
              " 后续请将新地址进行保存，或者在浏览器中进行收藏，旧地址将逐步取消！ "
            ),
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.gotoNewAddress },
                },
                [_vm._v("立即去新地址")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }